module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[51]50.6b518b3.woff2";